export enum ReservationStatus {
PENDING_PAYMENT = 'Pending Payment',
  CONFIRMED = 'Confirmed',
  PREPARING_SHIPMENT = 'Preparing Shipment',
  IN_DELIVERY = 'In Delivery',
  ACTIVE = 'Active',
  IN_USE_ISSUE = 'In-Use Issue',
  PENDING_RETURN = 'Pending Return',
  IN_RETURN = 'In Return',
  RETURNED = 'Returned',
  COMPLETED = 'Completed',
  CANCELED = 'Canceled',
  RETURN_ISSUE = 'Return Issue',
  PAYMENT_FAILED = 'Payment Failed',
}

export type ReservationStatusType = ReservationStatus | string;

export interface CreateReservationRequestDto {
  equipmentId: string;
  startDate: string; // YYYY-MM-DD or ISO
  endDate: string; // YYYY-MM-DD or ISO
  shippingAddress: string;
  province: string;
  city: string;
  cp: string; // 5 digits
  notes?: string | null;
  discountApplied?: number;
  insuranceIncluded?: boolean;
}

export interface ReservationResponseDto {
  id: string;
  reservationCode: string;
  userId: string;
  equipmentId: string;
  startDate: string; // ISO
  endDate: string; // ISO
  rentalDays: number;
  totalPrice: number;
  currency: string;
  status: ReservationStatusType;
  shippingAddress: string;
  province: string;
  city: string;
  cp: string;
  notes: string | null;
  discountApplied: number | null;
  insuranceIncluded: boolean;
  cancellationDate: string | null;
  returnedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PagedReservationResponseDto {
  data: ReservationResponseDto[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}
